module.exports = __webpack_public_path__ + "assets/retina_Cut2RectanglesDetailed.86569a0cb960919760af5b6d1e39e614.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_Cut2RectanglesDetailed.png
// module id = 653
// module chunks = 0